import React from 'react'
import { getCustomer as getAfgCustomer } from '@ally/data-selectors-afg-customer'
import { Alert, Box, Button, Space, TextHeading } from '@ally/metronome-ui'
import { useHostServices } from '../../HostServices'

const VehicleSoftLinkHeading: React.FC = () => {
  const { session } = useHostServices()
  return (
    <>
      If you&apos;re looking for your Auto account,{' '}
      <Button
        variant="link"
        text="log out"
        onClick={(): Promise<void> => session.delSession()}
      />{' '}
      then log back in with the username and password for that account.
      <br />
      This is temporary — we&apos;ll let you know when one login is all you
      need.
    </>
  )
}

const VehicleSoftLinkMessage: React.FC = () => {
  const { featureFlags, hostData } = useHostServices()
  const customer = getAfgCustomer(hostData)
  const hasMigration = Boolean(customer?.migration)
  const tpn = customer?.tpn

  const isAutoSoftLinkEnabled = featureFlags.variation(
    'FF_snapshot-auto-soft-link-message',
    false,
  )
  const showVehicleSoftLinkMessage =
    isAutoSoftLinkEnabled && tpn && !hasMigration

  if (!showVehicleSoftLinkMessage) return null

  return (
    <Box mb="lg" data-testid="vehicleSoftLinkMessage">
      <Space mb="sm">
        <TextHeading tag="h2" size="md">
          Vehicles
        </TextHeading>
      </Space>
      <Alert variant="info" heading={<VehicleSoftLinkHeading />} />
    </Box>
  )
}

export default VehicleSoftLinkMessage
